export function toNumber(v) {
  const n = Number(String(v ?? "").replace(/[^0-9.]/g, ""));
  return Number.isFinite(n) ? n : 0;
}

// Combine a base agreement value (without parking) with a parking-upgrade amount.
// Returns the base, the parking amount, and the combined "Total Agreement Value".
// The caller decides the base per context:
//   Change AV        -> the entered new AV, else the current agreement value
//   Approval Pending -> the submitted combined minus the stored parking
export function deriveAgreementValues({ baseValue, newParking }) {
  const base = Math.max(toNumber(baseValue), 0);
  const parking = toNumber(newParking);
  return { baseAV: base, parking, effectiveAV: base + parking };
}
